import Find from "pages/FindSection"
import Register from "pages/Accounts/Register"
import ProfitAndLost from "pages/Accounts/Report/ProfitAndLoss"
import OpeningBalance from "pages/Accounts/Transaction/OpeningBalance"
import Journal from "pages/Finance/Journal"
import GeneralEntry from "pages/Finance/Transaction/GeneralEntry"
import ClosingFinanceYear from "pages/Accounts/Transaction/ClosingFinanceYear"
import type { RouteType } from "types"
import Dashboard from "pages/Accounts/Dashboard"
import TransactionDetail from "pages/Accounts/Report/TransactionDetail"
import BugetManagerListPage from "pages/Accounts/Report/BugetManager/buget-manager-list-page"
import BugetVaranceListPage from "pages/Accounts/Report/BugetVarance/buget-varance-list-page"
import { PERMISION } from "security"

export const accountsRoutes: RouteType[] = [
  {
    path: "/accounts/register",
    element: <Register />,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "/accounts/transaction/opening-balance",
    element: <OpeningBalance />,
    permission: PERMISION.ACCOUNTS.TRANSACTION.OPENING_BALANCE.UPDATE
  },
  {
    path: "/accounts/report/profit-loss",
    element: <ProfitAndLost />,
    permission: PERMISION.ACCOUNTS.REPORT.BALANCE_SHEET.PERMISION || PERMISION.ACCOUNTS.REPORT.PROFIT_AND_LOSS.PERMISION
  },
  {
    path: "/accounts/journal",
    element: <Journal />,
    permission: PERMISION.ACCOUNTS.JOURNAL.PERMISION
  },
  {
    path: "/accounts/find",
    element: <Find />,
    permission: PERMISION.ACCOUNTS.FIND.PERMISION
  },
  {
    path: "/accounts/transaction/general-entry",
    element: <GeneralEntry />,
    permission: PERMISION.ACCOUNTS.TRANSACTION.GENERAL_ENTRY.CREATE
  },
  {
    path: "/accounts/transaction/chart-of-register",
    element: <div />,
    permission: "AT03"
  },
  {
    path: "/accounts/report/transaction-journal",
    element: <div />,
    permission: "AT04"
  },
  {
    path: "/accounts/transaction/task-record",
    element: <div />,
    permission: "AT05"
  },
  {
    path: "/accounts/report/dashboard",
    element: <Dashboard />,
    permission: PERMISION.ACCOUNTS.REPORT.DASHBOARD.PERMISION
  },
  {
    path: "/accounts/report/transaction-detail",
    element: <TransactionDetail />,
    permission: PERMISION.ACCOUNTS.REPORT.TRANSACTION_DETAIL.READ
  },
  {
    path: "/accounts/report/account-list-summary",
    element: <div />,
    permission: "AP03"
  },
  {
    path: "/accounts/report/account-list-detail",
    element: <div />,
    permission: "AP04"
  },
  {
    path: "/accounts/report/general-ledger-summary",
    element: <div />,
    permission: "AP05"
  },
  {
    path: "/accounts/report/general-ledger-detail",
    element: <div />,
    permission: "AP06"
  },
  {
    path: "/accounts/report/bugget-analist",
    element: <div />,
    permission: "AP07"
  },
  {
    path: "/accounts/report/general-journal-transactions",
    element: <div />,
    permission: "AP08"
  },
  {
    path: "/accounts/report/buget-manager",
    element: <BugetManagerListPage />,
    permission: PERMISION.ACCOUNTS.REPORT.BUDGET_MANAGER.PERMISION
  },
  {
    path: "/accounts/report/buget-variance",
    element: <BugetVaranceListPage />,
    permission: PERMISION.ACCOUNTS.REPORT.BUDGET_VARIANCE.PERMISION
  },
  {
    path: "/accounts/transaction/closing-finance-year",
    element: <ClosingFinanceYear />,
    permission: PERMISION.ACCOUNTS.TRANSACTION.CLOSING_FINANCE_YEAR.CREATE
  }
]
